<template>
  <div>
    <upload v-model="urlArr" :limit="3" :url="url" :size="size" :auth="auth">
      <el-button type="primary">主要按钮</el-button>
    </upload>
  </div>
</template>

<script>
import upload from "../common/upload1";
export default {
  data() {
    return {
      urlArr: [],
      url: "",
      size: 1024 * 1024 * 1,
      auth: {},
      filetype: [
        { name: "doc", value: 1 },
        { name: "docx", value: 1 },
        { name: "ppt", value: 2 },
        { name: "pptx", value: 2 },
        { name: "pdf", value: 3 },
        { name: "png", value: 4 },
        { name: "jpg", value: 4 },
        { name: "jpeg", value: 4 },
        { name: "gif", value: 4 },
        { name: "bmp", value: 4 },
        { name: "mp4", value: 5 },
      ],
    };
  },
  components: { upload },
  mounted() {
    this.url = window.sessionStorage.getItem("uploadUrl");
    this.auth = {
      clientId: window.sessionStorage.getItem("clientId"),
      token: window.sessionStorage.getItem("token"),
    };
  },
  methods: {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/a.vue